<div class="layout-wrapper" [ngClass]="containerClass">

  <!-- Header sticky: menubar + breadcrumb en fascicle-edit -->
  <div class="layout-header">
    <app-menubar></app-menubar>
    <div class="layout-breadcrumb-bar" *ngIf="isFascicleEdit">
      <app-breadcrumb></app-breadcrumb>
    </div>
  </div>

  <!-- Zona de contenido: gradiente visible en los márgenes laterales -->
  <div class="layout-main-content" [ngClass]="isFascicleEdit ? 'p-0' : ''">

    <!-- Caja blanca centrada (Boxed Layout) — no aplica en fascicle-edit -->
    <div class="layout-content-box" [ngClass]="{'layout-content-box--raw': isFascicleEdit}">

      <!-- Breadcrumb + botón volver dentro de la tarjeta -->
      <div class="cc-card-nav" *ngIf="!isFascicleEdit">
        <button class="cc-card-back-btn" *ngIf="breadcrumbs.length > 1" (click)="goBack()" type="button">
          <i class="pi pi-arrow-left"></i>
        </button>
        <app-breadcrumb></app-breadcrumb>
      </div>

      <!-- Estado de carga durante navegación -->
      <div class="layout-loading" *ngIf="isNavigating">
        <p-progressBar [mode]="'indeterminate'" [style]="{ height: '3px', width: '180px' }"></p-progressBar>
        <p>{{ 'USER.WAIT' | translate }}</p>
      </div>

      <!-- Contenido de la página -->
      <div class="page-content-wrapper" [ngClass]="{'page-content-wrapper--raw': isFascicleEdit}" *ngIf="!isNavigating">
        <router-outlet></router-outlet>
      </div>

      <!-- Footer de la tarjeta -->
      <footer class="cc-card-footer" *ngIf="!isFascicleEdit">
        &copy; Nousmedis 2021&ndash;{{ currentYear }}
      </footer>

    </div>
  </div>

</div>
